module.exports = __webpack_public_path__ + "static/media/cofretiny.aa17bab1.png";